export default {
  configReducerState: {
    initialUserRightHasBeenLoaded: false,
    initialUserRightHasBeenLoadedWithError: false,
    userToken: "",
    currentWorkspace: {},
  },
  topicReducerState: {
    curatedRegHubTopicsAreLoading: false,
    curatedRegHubTopicsHaveLoadedWithError: false,
    curatedRegHubTopics: [],
    mySelectionTopics: [],
    singleTopic: {},
    singleTopicIsLoading: false,
    singleTopicIsLoadedWithError: false,
    topicErrorMessage: "",
    topicSuccessMessage: "",
  },
  userReducerState: {
    userRegistrationIsLoading: false,
    userRegistrationSuccessMessage: "",
    userRegistrationIsLoadedWithError: false,
    userRegistrationErrorMessage: "",
    user: {},
    workspacesOfUser: [],
    userLoggingIsLoading: false,
    userLoggingIsLoadedWithError: false,
    userLoggingErrorMessage: "",
    loggedIn: false,
    userRights: {},
  },
  filterReducerState: {
    filtersAreLoading: false,
    filtersAreLoadedWithError: false,
    filters: [],
    filtersTypesAreLoading: false,
    filtersTypesAreLoadedWithError: false,
    filtersTypes: [],
    currentFilter: {},
    filterSuccessMessage: "",
    filterFailureMessage: "",
    regulatoryStream: [],
    regulatoryStreamAreLoading: false,
    regulatoryStreamLoadedWithError: false,
    regulatoryStreamPaginationError: false,
    top5Publishers: {},
    top5PublishersAreLoading: false,
    top5PublishersLoadedWithError: false,
    top5Countries: {},
    top5CountriesAreLoading: false,
    top5CountriesLoadedWithError: false,
    hotTopics: {},
    hotBusinessUnits: {},
    hotTopicsAndBusinessUnitsAreLoading: false,
    hotTopicsAndBusinessUnitsLoadedWithError: false,
    graphAggregations: [],
    graphAggregationsAreLoading: false,
    graphAggregationsAreLoadedWithError: false,
    singleDocument: {},
    singleDocumentIsLoading: false,
    singleDocumentIsLoadedWithError: false,
    singleSimilarDocument: [],
    singleSimilarDocumenIsLoading: false,
    singleSimilarDocumenIsLoadedWithError: false,
    graphAggregationsTotalAmount: 0,
  },
  tileReducerState: {
    tilesAreLoading: false,
    tilesAreLoadedWithError: false,
    tileTypesAreLoading: false,
    tileTypesAreLoadedWithError: false,
    tilesOfTypeLinksAreLoading: false,
    tilesOfTypeLinksAreLoadedWithError: false,
    tilesOfTypeLinks: [],
    tiles: [],
    topicTiles: [],
    additionalTiles: [],
    tileTypes: [],
    tileSuccessMessage: "",
    tileErrorMessage: "",
    singleTileIsLoading: false,
    singleTileIsLoadedWithError: false,
    singleTile: {},
  },
  sourceReducerState: {
    sourcesAreLoading: false,
    sourcesSuccessMessage: "",
    sourcesAreLoadedWithError: false,
    sourcesAreLoadedWithErrorMessage: "",
    sources: [],
    previewedCrawlerSource: {},
  },
  askQuestionReducer: {
    aIResponseAreLoading: false,
    aiQuestionAreLoadedWithError: false,
    response: [],
    aiQuestionErrorMessage: "",
  },
};
